export default __webpack_public_path__ + "static/media/656.609b0b27.gif";